import styles from './NewCanvasMenu.module.scss'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import UploadPPT from '../../../Objects/UploadPPT/UploadPPT'
import { PlusIcon, MicrosoftPowerpointLogoIcon, ShapesIcon } from '@phosphor-icons/react'
import { NewFromRecipe } from '../../Source/NewDatasetModal/NewFromRecipe/NewFromRecipe'
import { useModal, MODALS } from '../../../modals'
import { ScoopMenu, ScoopMenuItem } from '../../../ui'
import { setPresentationLoading } from '../../../../store/actions/uiActions'
import { EVENTS, trackEvent } from '../../../../events'
import { useWorkspaceMetadata } from '../../../../api/hooks/workspaceMetadata/useWorkspaceMetadata'
import { useIsTourWorkspace } from '../../../../hooks/useIsTourWorkspace'

export const NewCanvasMenu = ({ anchorEl, onClose, startInterval, open, createdInbox, mode }) => {
    const navigate = useNavigate()
    const openByOnboarding = useSelector((state) => state.ui.showRecipeModal)

    const dispatch = useDispatch()
    const [showPPTUpload, setShowPPTUpload] = useState(false)
    const [showNewFromRecipe, setShowNewFromRecipe] = useState(false)
    const createCanvasModal = useModal(MODALS.CANVAS.CREATE)

    const { workspaceMetadata } = useWorkspaceMetadata()

    // Modal Manager hook
    const generateModal = useModal(MODALS.COMMON.GENERATE_INSIGHT)

    useEffect(() => {
        const recipeMapping = localStorage.getItem('recipeMapping')
        if (recipeMapping) setShowNewFromRecipe(true)
        if (createdInbox && mode) {
            if (mode === 'presentation') {
                generateModal.show({
                    inboxes: workspaceMetadata?.inboxes || [],
                    onGenerateSuccess: handleOnGenerateSuccess,
                    onGenerateError: () => {},
                    generateInsight: false,
                    workspaceMetadata,
                    createdInbox,
                })
            }
            if (mode === 'recipe') setShowNewFromRecipe(true)
        }
    }, [])

    const createCanvasFromPPT = () => {
        setShowPPTUpload(true)
        trackEvent(EVENTS.CANVAS.CREATE_FROM_PRESENTATION_ATTEMPT)
        onClose()
    }

    const closePPTUpload = () => {
        setShowPPTUpload(false)
    }

    const handleCreateBlankCanvas = async () => {
        onClose()
        const newCanvasID = await createCanvasModal.show()
        if (newCanvasID) {
            navigate(newCanvasID, { state: 'newCanvas' })
        }
    }

    const isDefaultWorkspace = useIsTourWorkspace()

    const renderNewPopover = () => {
        return (
            <ScoopMenu
                open={open}
                anchorEl={anchorEl}
                onClose={onClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                className={styles.popoverContent}
            >
                <ScoopMenuItem
                    height={50}
                    leftSection={
                        <div className={styles.iconContainer}>
                            <PlusIcon size={20} color="#E50B54" />
                        </div>
                    }
                    primary="Blank Canvas"
                    secondary="Create an empty canvas to design yourself"
                    onClick={handleCreateBlankCanvas}
                />
                <ScoopMenuItem
                    height={50}
                    leftSection={
                        <div className={styles.iconContainer}>
                            <MicrosoftPowerpointLogoIcon size={20} color="#E50B54" />
                        </div>
                    }
                    primary="Canvas from Presentation"
                    secondary="Bring your Powerpoint slides into a new canvas"
                    disabled={isDefaultWorkspace}
                    onClick={createCanvasFromPPT}
                />
                <ScoopMenuItem
                    height={50}
                    leftSection={
                        <div className={styles.iconContainer}>
                            <ShapesIcon size={20} color="#E50B54" />
                        </div>
                    }
                    primary="Canvas from Recipe"
                    secondary="Pre-made canvases for telling specific data stories"
                    disabled={isDefaultWorkspace}
                    onClick={() => {
                        setShowNewFromRecipe(true)
                        onClose()
                    }}
                />
            </ScoopMenu>
        )
    }

    const handleOnGenerateSuccess = () => {
        dispatch(setPresentationLoading(true))
        onClose()
    }

    return (
        <>
            {renderNewPopover()}
            {showPPTUpload && <UploadPPT isOpen={showPPTUpload} onClose={closePPTUpload} />}
            {(showNewFromRecipe || openByOnboarding) && (
                <NewFromRecipe
                    isOpen={showNewFromRecipe || openByOnboarding}
                    setOpen={setShowNewFromRecipe}
                    createdInbox={createdInbox}
                />
            )}
        </>
    )
}
